import { Navigate, useParams } from "react-router-dom";
import FriendsOfDwfPartnerPage from "./partner-page";

export default function FriendsOfDwfPartnerRoutePage() {
  const { partnerSlug } = useParams();

  if (!partnerSlug) {
    return <Navigate to="/app/friends-of-dwf" replace />;
  }

  return <FriendsOfDwfPartnerPage partnerSlug={partnerSlug} />;
}
